import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Radio, RadioTitleLabel, RadioWrapper, RadioOptionWrapper} from './RadioField.styled';
import {TooltipError} from '@components/atoms/Tooltip/Tooltip.styled';
import {
  FieldWrapper,
  TitleLabel,
} from '@components/atoms/Field/Field.styled';

const RadioField = ({id, name, value, required, label, className, onClick, opts}) => {
  const [isInvalid, setIsInvalid] = useState(false);

  const invalid = (event) => {
    setIsInvalid(event.type && event.type === 'invalid');
  };

  const handleClick = (event) => {
    onClick(event);
    if (required) {
      setIsInvalid(!!!event.target.value);
    }
  };

  return (
    <FieldWrapper data-testid={`radio_wrapper_${id}`}>
      {(isInvalid && (
        <TooltipError data-testid={`radio_error_${id}`} $content={'Ce champs est requis.'} />
      )) || <></>}
      <TitleLabel $iserror={isInvalid}>{label}</TitleLabel>
      <RadioWrapper>
        {opts.map((opt, key) => {
          const checked = value === opt.id;
          return (
            <RadioOptionWrapper key={key} $checked={checked} onClick={handleClick}>
              <Radio
                data-testid={`radio_${id}_${key}`}
                key={key}
                name={`${name}`}
                required={required}
                id={opt.id}
                type='radio'
                value={opt.id}
                className={className}
                checked={checked}
                $iserror={isInvalid}
                onClick={handleClick.bind(this)}
                onChange={handleClick.bind(this)}
                onInvalid={invalid.bind(this)}
              />{' '}
              <RadioTitleLabel htmlFor={opt.id} $iserror={isInvalid}>
                {opt.name}
              </RadioTitleLabel>
            </RadioOptionWrapper>
          );
        })}
      </RadioWrapper>
    </FieldWrapper>
  );
};

RadioField.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  required: PropTypes.bool.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  opts: PropTypes.array.isRequired,
  onClick: PropTypes.func,
};

export default RadioField;
